<template>
	<div class="container">
    <header-compent activeName="apporder" :agent="agent" :usertype="usertype" :is_manager="is_manager" :suite_name="suite_name" :suite_id="suite_id"></header-compent>
    	<div class="page-header"><div  class="el-page-header"><div class="el-page-header__content">订单管理</div></div></div>

    	<div class="page-body">

 			 <el-table
			    :data="orderList"
			    stripe
			    style="width: 100%"
			    >
				 <el-table-column
			      prop="id"
			      label="ID"
			      >
			    </el-table-column>
         <el-table-column
           prop="orderid"
           label="订单号"
         >
         </el-table-column>
         <el-table-column
            prop="suiteid"
            label="应用名称"
            >
            <template slot-scope="scope">
              <span v-if="scope.row.suiteid == 'wwe1672b8556d5bfeb'" style="color: forestgreen;">群互动</span>
              <span v-if="scope.row.suiteid == 'wwd579740c7542b9c5'"  style="color: dodgerblue;">互动小工具</span>
              <span v-if="scope.row.suiteid == 'wwae097389e8998ec1'"  style="color: cornflowerblue;">互动大转盘</span>
              <span v-if="scope.row.suiteid == 'wwd90c4c627ba10fad'"  style="color: orangered;">互动活动</span>
            </template>
          </el-table-column>

         <el-table-column
           prop="order_status"
           label="订单状态"
         >
          <template slot-scope="scope">
			       	<span v-if="scope.row.order_status==0">
				    	待支付
				    </span>
             <span v-if="scope.row.order_status==1">
				    	已支付
				    </span>
             <span v-if="scope.row.order_status==2">
				    	已取消
				    </span>
             <span v-if="scope.row.order_status==3">
				    	支付过期
				    </span>
             <span v-if="scope.row.order_status==4">
				    	申请退款中
				    </span>
             <span v-if="scope.row.order_status==5">
				    	退款成功
				    </span>
             <span v-if="scope.row.order_status==6">
				    	退款被拒绝
				    </span>

           </template>
         </el-table-column>
         <el-table-column
           prop="order_type"
           label="订单类型"
         >
<!--           订单类型。0-新购应用，1-扩容应用人数，2-续期应用时间，3-变更版本-->
           <template slot-scope="scope">
			       	<span v-if="scope.row.order_type==0">
				    	新购应用
				    </span>
             <span v-if="scope.row.order_type==1">
				    	扩容应用人数
				    </span>
             <span v-if="scope.row.order_type==2">
				    	续期应用时间
				    </span>
             <span v-if="scope.row.order_type==3">
				    	变更版本
				    </span>
           </template>

         </el-table-column>
         <el-table-column
           prop="operator_id"
           label="下单人员ID"
         >
         </el-table-column>
         <el-table-column
           prop="edition_id"
           label="购买版本ID"
         >
         </el-table-column>
         <el-table-column
           prop="edition_name"
           label="购买版本名称"
         >
         </el-table-column>
         <el-table-column
           prop="price"
           label="金额"
         >
           <template slot-scope="scope">
             {{scope.row.price/100}}
           </template>
         </el-table-column>
         <el-table-column
           prop="user_count"
           label="购买账号数量"
         >
         </el-table-column>
         <el-table-column
           prop="order_period"
           label="购买时长（天）"
         >
         </el-table-column>
         <el-table-column
           prop="order_time"
           label="下单时间"
         >
         </el-table-column>
         <el-table-column
           prop="paid_time"
           label="付款时间"
         >
         </el-table-column>
         <el-table-column
           prop="begin_time"
           label="购买生效时间"
         >
         </el-table-column>
         <el-table-column
           prop="end_time"
           label="购买失效时间"
         >
         </el-table-column>




			    <el-table-column
			      prop="create_time"
			      label="创建时间"
			      >
			    </el-table-column>

				 <el-table-column
			      prop="active_status"
			      label="操作"
			     >
			      <template slot-scope="scope">
				    <el-button size="mini" type="primary" class="ml10" @click="showActiveUsers(scope.row.id)" v-if="scope.row.active_status>0">查看激活名单</el-button>
			      </template>
			    </el-table-column>


			  </el-table>

 			 <div class="mt20 mb20">
				    <el-pagination
				      @size-change="handleSizeChange"
				      @current-change="handleCurrentChange"
				      :current-page="query.page"
				      :page-sizes="[10, 20, 30, 50]"
				      :page-size="query.limit"
				      layout="total, sizes, prev, pager, next"
				      :total="total">
				    </el-pagination>
			 </div>



    	</div>

    	<el-dialog title="订单激活用户" :visible.sync="dialogOrderListVisible" width="970px">
	    	 <el-table
			    :data="orderUserList"
			    stripe
			    style="width: 100%"
			    >
			    <el-table-column
			      prop="id"
			      label="ID"
			      >
			    </el-table-column>

			    <el-table-column
			      prop="open_userid"
			      label="用户名"
			      >
			       <template slot-scope="scope">
						<ww-open-data type="userName" :openid="scope.row.open_userid" v-if="agent==1" />
						<span v-else>{{scope.row.open_userid}}</span>
				    </template>
			    </el-table-column>
			    <el-table-column
			      prop="create_time"
			      label="时间"
			      >
			    </el-table-column>

				<el-table-column
			      prop="status"
			      label="激活状态"
			     >
			      <template slot-scope="scope">
			       	<span v-if="scope.row.status==0">无效</span>
				    <span v-if="scope.row.status==1">激活中，等待专员激活</span>
				    <span v-if="scope.row.status==2">已激活</span>
				    <span v-if="scope.row.status==3">激活失效</span>
			      </template>
			   </el-table-column>
			</el-table>

    	</el-dialog>



    </div>
</template>

<script>
import {postOrderList, postOrderActiveDetail, postAppOrderList} from "../api/index";
import Cookies from "js-cookie";
import HeaderCompent from "./header.vue";


export default {
  name: 'index',
   components: {
	HeaderCompent
  },
  data () {
    return {
	    isSending:false,
	    orderList:[],

	    query:{
	    	page:1,
	    	limit:10
	    },
	    total:0,



	    agent:Cookies.get('agent') || '0',
      agent_dzp:Cookies.get('agent_dzp')|| 0,
      agent_hd:Cookies.get('agent_hd')|| 0,
      agent_xgj:Cookies.get('agent_xgj')|| 0,

	    usertype:Cookies.get('usertype') || '0',
	    orderUserList:[],
	    dialogOrderListVisible:false,
      is_manager: Cookies.get('is_manager') || 0,
      suite_id_list:[
       {name:'群互动',suite_id:'wwe1672b8556d5bfeb',avatar:'https://api-group.chouchoujiang.com/static/admin/images/logo.png'},
       {name:'互动小工具',suite_id:'wwd579740c7542b9c5',avatar:'https://static.ccxia.cn/Uploads/lottery/2508/68995e100d946.png'},
       {name:'互动大转盘',suite_id:'wwae097389e8998ec1',avatar:'https://static.ccxia.cn/Uploads/lottery/2508/68995e50b605a.png'},
       {name:'互动活动',suite_id:'wwd90c4c627ba10fad',avatar:'https://static.ccxia.cn/Uploads/lottery/2508/68995ed02934a.png'},
      ],
      suite_id:Cookies.get('suite_id') || '',
      suite_name:Cookies.get('suite_name') || '',


    }

  },
  methods:{
  	showActiveUsers(e){
  		if(this.isSending == true){
			console.log('请稍等');
			return false;
		}

	   	this.isSending = true;
  		postOrderActiveDetail({order_id:e}).then((res) => {

	      	this.isSending = false;
	        let { msg, code, data } = res.data;

			if(code == 200){

				this.orderUserList = data.list;
				this.dialogOrderListVisible = true;

			}



	      },reject=>{
	      	 this.isSending = false;
	      	 let { msg, code, data } = reject.data;
	      	 if(code == 401){
	      	 	Cookies.remove('token');
	      	 	this.$router.push('/login')
	      	 }

	      });
  	},
  	handleSizeChange(e){
  		this.query.limit = e;
  		this.fnGetOrderList();
  	},
  	handleCurrentChange(e){
  		this.query.page = e;
  		this.fnGetOrderList();

  	},


  	//获取用户列表
   	fnGetOrderList(){
		if(this.isSending == true){
			console.log('请稍等');
			return false;
		}

	   	 this.isSending = true;
      postAppOrderList(this.query
	     ).then((res) => {

	      	this.isSending = false;
	        let { msg, code, data } = res.data;

			if(code == 200){
				this.orderList = data.data

				this.total = data.total;
			}



	      },reject=>{
	      	 this.isSending = false;
	      	 let { msg, code, data } = reject.data;
	      	 if(code == 401){
	      	 	Cookies.remove('token');
	      	 	this.$router.push('/login')
	      	 }

	      });
   	},

  },
  created(){
  	 console.log(process.env.BASE_API)
  	 console.log(process.env.PAY_MONTH)
  	  this.token = Cookies.get('token');
  	  if(!this.token){
  	  	this.$router.push('/login');
  	  }
  	  else{
  	  	this.fnGetOrderList();

  	  }

  },
  mounted(){

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped  type="text/scss" lang="scss" >

	.item{
		margin: 20px auto;
	}
	.qr-code {
	  text-align: center;
	  .subtitle {
	    padding: 15px 0 30px;
	  }
	  .tips {
	    padding-top: 25px;
	    img{
	    	margin-right: 10px;
	    }
	  }
	}

	.help_title {
	  text-align: left;
	  .subtitle {
	    padding: 10px;
	  }
	  .tips {
	    padding-top: 25px;
	    img{
	    	margin-right: 10px;
	    }
	  }
	}
</style>



// WEBPACK FOOTER //
// src/components/apporderList.vue